<template>
  <!-- 轻课 || 训练营-->
  <template
    v-if="goodsType == constants.goodsType.course || goodsType == constants.goodsType.training"
  >
    <div class="c-head-info">
      <div class="c-course-price pb30">
        <span class="f30 fb">¥</span>
        {{courseInfo.newPrice}}
        <del
          class="c-line-price"
          v-if="courseInfo.linePrice > 0"
        >￥{{courseInfo.linePrice}}&nbsp;</del>
        <img
          v-if="memberVip==1"
          class="discount-img"
          src="~@/assets/images/vip/discount-img.png"
          alt
        />
      </div>
      <div class="c-course-name">{{courseInfo.name}}</div>
      <div class="c-course-desc">{{courseInfo.shareDescription}}</div>
      <div
        class="c-course-lesson-count"
        v-if="courseInfo.lessonCount"
      >已更新{{courseInfo.publishedCount}}/{{courseInfo.lessonCount}}讲</div>
    </div>
  </template>
  <!-- 私教坊 -->
  <template v-if="goodsType == constants.goodsType.offlineClass">
    <div class="c-head-info">
      <div class="c-course-name">{{courseInfo.name}}</div>
      <div class="c-course-price pt10">
        <span class="f30 fb">¥</span>
        {{courseInfo.newPrice}}
        <del
          class="c-line-price"
          v-if="courseInfo.linePrice > 0"
        >￥{{courseInfo.linePrice}}&nbsp;</del>
        <img
          v-if="memberVip==1"
          class="discount-img"
          src="~@/assets/images/vip/discount-img.png"
          alt
        />
      </div>
    </div>
    <div class="c-course-info tl">
      <div>
        <span class="iconfont icon-shijian"></span>
        <span class="f30">{{dates.formatTimeLong(courseInfo.startTime,courseInfo.endTime)}}</span>
      </div>
      <div>
        <span class="iconfont icon-dingwei"></span>
        <span class="f30" v-if="courseInfo.city">
          {{courseInfo.city}}
          <template v-if="!!courseInfo.venuesName">｜{{courseInfo.venuesName}}</template>
        </span>
      </div>
      <div class="address" v-if="address">{{courseInfo.address}}</div>
    </div>
  </template>
  <template v-if="goodsType == constants.goodsType.column">
    <div class="c-column-wrap">
      <div class="c-title">专栏包含</div>
      <div class="c-column-list" v-show="courseInfo.courseList && courseInfo.courseList.length>1">
        <div
          class="c-card"
          v-for="item in courseInfo.courseList"
          :key="item.id"
          @click="jumpPage(item)"
        >
          <img :src="item.imageA" alt />
          <div class="price">
            <span class="f30 fb pr10">¥</span>
            {{item.newPrice}}
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import dates from '@/utils/dates'
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    memberVip: {
      type: [Number, String],
      default: '',
    },
    goodsType: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      dates,
    }
  },
  methods: {
    jumpPage(item) {
      this.$router.push({
        name: 'column-course',
        query: {
          goodsId: item.goodsId,
          adminId: item.adminId,
          goodsType: this.constants.goodsType.course,
        },
      })
    },
  },
}
</script>

<style scoped lang="less">
.c-head-info {
  padding: 50px 32px 40px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: left;
  font-weight: 600;
  line-height: 1;

  .c-course-name {
    font-size: 32px;
    color: #222222;
    margin-bottom: 14px;
    line-height: 42px;
    font-weight: bold;
  }
  .c-course-desc {
    width: 586px;
    font-size: 28px;
    color: #888888;
    line-height: 38px;
  }
  .c-course-lesson-count {
    font-size: 26px;
    color: #888888;
    line-height: 26px;
    padding-top: 23px;
  }
  .c-course-price {
    color: #888;
    font-size: 40px;
    color: #ff5500;
    font-weight: bold;

    .c-line-price {
      font-size: 30px;
      padding-left: 40px;
      font-weight: 500;
      color: #aaaaaa;
      line-height: 1;
    }
  }
}
.c-course-info {
  padding: 18px 32px;
  margin-top: 20px;
  background: #fff;
  color: #333;
  line-height: 68px;
  .iconfont {
    padding-right: 16px;
    font-size: 36px;
  }
  .address {
    padding-left: 52px;
    line-height: 26px;
    font-size: 26px;
    color: #888;
    padding-bottom: 20px;
  }
}
// 专栏

.c-column-wrap {
  background-color: #fff;
  padding: 20px 32px 40px;
  position: relative;
  .c-title {
    width: 76px;
    background: #eca459;
    padding: 0 24px;
    font-size: 28px;
    line-height: 1;
    color: #ffffff;
    writing-mode: tb-rl;
    text-align: center;
    border-radius: 12px 0px 0px 12px;
    position: absolute;
    left: 30px;
    top: 20px;
    bottom: 40px;
    z-index: 2;
  }
}
.c-column-list {
  padding-left: 88px;
  padding-top: 20px;
  display: flex;
  overflow: auto;
  background-color: #fff8f1;
  width: 718px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.09);
  .c-card {
    padding: 0 11px;
    flex: 272px 0 0;
    .price {
      font-size: 28px;
      line-height: 52px;
      padding-bottom: 8px;
      color: #f45b07;
    }
    img {
      width: 250px;
      height: 140px;
      background: #d8d8d8;
      border-radius: 8px;
    }
  }
}
</style>